var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[_c('div',{staticClass:"topbar-item mr-4"}),_c('KTQuickUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }